import * as TYPES from './types';
export default {
    [TYPES.SET_SOCIAL_LINKS](payload) {
        this.socialLinks = [...payload];
    },
    [TYPES.SET_POSTS]({ posts, pageNo, hasMore }) {
        this.posts = [...posts]
        this.pageNo = pageNo
        this.hasMore = hasMore
    },
};
